export default __webpack_public_path__ + "static/media/frame-card-warlord.7f751a50.png";